import { ErrorBoundary } from '@components/ErrorBoundary';
import { RootLayout } from '@components/layouts/RootLayout';

import { sentryCreateBrowserRouter } from './instrument';
import { routes } from './routes';

export const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: routes,
  },
]);
